/** Browser privacy signals (e.g. CPRA Global Privacy Control). */

export function isGlobalPrivacyControlEnabled(): boolean {
  if (typeof navigator === "undefined") return false;
  return navigator.globalPrivacyControl === true;
}
